<app-loader *ngIf="isLoading()"></app-loader>

<div class="container container-profile" [ngClass]="containerClass()" [class.d-none]="isLoading()">

  <!-- Top panel with avatar and name -->
  @if (account()) {
    <div class="card card-white top-panel mt-4 mb-4">
      <div class="card-body">

        <div class="row">
          <div class="col-12 col-md-4">

            <div class="profile-image-wrapper">

              <div class="editable-group">
                <div class="edit-icon">
                  <fa-icon [icon]="faEdit" (click)="editAvatar.emit()"></fa-icon>
                </div>
              </div>

              <div class="profile-image-holder circle">
                <img class="profile-image image img-fluid" [src]="avatarUri() || '/assets/img/placeholder/image-placeholder-profile.jpg'">
              </div>
            </div>

          </div>

          <div class="col-12 col-md-8">

            <h2 class="title">
              {{resolvedName()}} <small *ngIf="profileCity()">({{profileCity()}})</small>
            </h2>

            <ng-content select="[topPanelExtra]"></ng-content>

          </div>

        </div>

        <ng-content select="[topPanelActions]"></ng-content>

      </div>
    </div>
  }

  <ng-content select="[profileTopPanel]"></ng-content>

  <div class="content">
    <div class="row">

      <div class="col-12 col-md-4 sidebar sidebar-left">

        <div class="card">
          <div class="card-body p-0">
            <ul class="nav flex-column font-weight-bold">
              @for (tab of visibleTabs(); track tab.id) {
                <li class="nav-item">
                  @if (tab.isRouterLink && tab.routerLink) {
                    <a class="nav-link cursor-pointer"
                       [class.pl-5]="tab.indent"
                       [routerLink]="tab.routerLink"
                       [queryParams]="tab.queryParams ?? {}">
                      <fa-icon [icon]="tab.icon" [class]="tab.iconClass ?? 'text-primary'" class="mr-2"></fa-icon>
                      {{tab.label | translate}}
                    </a>
                  } @else {
                    <a class="nav-link cursor-pointer"
                       [class.active]="activeTab() === tab.id"
                       [class.pl-5]="tab.indent"
                       (click)="selectTab(tab)"
                       (keydown.enter)="selectTab(tab)"
                       tabindex="0">
                      <fa-icon [icon]="tab.icon" [class]="tab.iconClass ?? 'text-primary'" class="mr-2"></fa-icon>
                      {{tab.label | translate}}
                    </a>
                  }
                </li>
              }
            </ul>
          </div>
        </div>

        <!-- Contact details card -->
        @if (account()) {
          <div class="card mt-4">
            <div class="card-body">
              <h4 class="card-title">{{'Contact details' | translate}}</h4>

              <!--
                Definition-grid: column 1 (auto) sizes to the widest label across
                ALL rows — including the projected address — so every value lines
                up. Projected contact-detail rows join this same grid via
                display:contents on their wrappers (see [contactDetailsExtra]).
              -->
              <div class="grid grid-cols-[auto_1fr] gap-x-6 gap-y-2 text-sm">
                <div class="text-mty-body/60">{{'First name' | translate}}</div>
                <div class="text-mty-body break-words">{{account()?.firstName}}</div>

                <div class="text-mty-body/60">{{'Last name' | translate}}</div>
                <div class="text-mty-body break-words">{{account()?.lastName}}</div>

                @if (account()?.phoneNumber) {
                  <div class="text-mty-body/60">{{'Phone number' | translate}}</div>
                  <div class="text-mty-body break-words">{{account()?.phoneNumber}}</div>
                }
                @if (account()?.emailAddress) {
                  <div class="text-mty-body/60">{{'Email' | translate}}</div>
                  <div class="text-mty-body break-words">{{account()?.emailAddress}}</div>
                }

                <ng-content select="[contactDetailsExtra]"></ng-content>
              </div>
            </div>
          </div>
        }

        <ng-content select="[profileSidebarExtra]"></ng-content>

      </div>

      <div class="col-12 col-md-8 main main-right">
        <ng-content select="[profileTabContent]"></ng-content>
      </div>

    </div>
  </div>

</div>
